import { isEmpty } from 'lodash-es';

import { Filter } from '../../common/register/filters/filter';
import { FormFieldHeaderColumn } from '../../common/register/form-field-header/form-field-header-column';

export class TableFilter extends Filter {
  columns: FormFieldHeaderColumn[];

  constructor(columns: FormFieldHeaderColumn[]) {
    super(null);
    this.columns = columns;
  }

  queryParams() {
    const result = {};

    this.columns.forEach((column) => {
      if (column.filter && !isEmpty(column.filter.queryParams())) {
        result[column.id] = column.filter.queryParams();
      }
    });

    return result;
  }

  get status(): number {
    return this.columns.reduce((sum, column) => sum + (column.filter ? column.filter.status : 0), 0);
  }

  reset() {
    this.columns.forEach((column) => column.filter && column.filter.reset());
  }

  set(params: any) {
    if (!params) {
      this.reset();
      return;
    }

    this.columns.forEach((column) => {
      if (column.filter) {
        column.filter.set(params[column.id]);
      }
    });
  }
}
